import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  ExportProximityDataContainer, type ExportProximityDataContainerProps,
} from './exportProximityData.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    ExportProximityData: ExportProximityDataContainerProps;
  }
}
modalRenderer.register('ExportProximityData', ExportProximityDataContainer);
